<div class="left">
  <div class="form column titles-column">
    <div
      class="pr-[15px] box-border flex gap-1"
      [ngClass]="{
        'pl-4': isSubItem,
      }"
    >
      <div cdkDragHandle class="icon-draggable flex items-center justify-center text-blue-700 cursor-grab"></div>
      <div
        class="spend-name-input-gc"
        [ngClass]="{
          'bg-navy-200': !isSubItem,
          'bg-green-100': isSubItem,
        }"
      >
        <div class="name">{{ item.name }}</div>
        <div class="other-info">{{ item.division }}</div>
      </div>
    </div>
  </div>
  <div class="form column budget-area">
    <div class="input total-year">
      <app-spend-custom-input
        [disabled]="true"
        (valueChange)="setItemTotal($event, item); calcDistribution(item)"
        class="app-custom-input prime-spend-input"
        [value]="item.project_total"
        [ngClass]="{
          'totals-match-error':
            item.project_total !== item.original_prime_total && item.prime_distribution === DISTRIBUTION_TYPES.MANUAL,
          'subitem-spend-input-bg': isSubItem,
          'spend-input-bg': !isSubItem,
        }"
        [appTooltip]="
          item.project_total !== item.original_prime_total && item.prime_distribution === DISTRIBUTION_TYPES.MANUAL
            ? 'For manual distribution with contract, the total must be equal to the initial total which is ' +
              (item.original_prime_total >= 0
                ? '$' + item.original_prime_total
                : '($' + item.original_prime_total * -1 + ')')
            : ''
        "
      >
      </app-spend-custom-input>
    </div>
  </div>
</div>
<div class="right">
  <div class="distribution-type-area">
    @if (isSubItem) {
      <div class="input column">
        <app-input-calendar
          [minStartDate]="minStartDate"
          [date]="item.prime_start_date"
          (dateChanged)="setStartDate($event, item); calcDistribution(item)"
          [showLabel]="false"
          [name]="'prime_start_date_' + item.id"
          topPosition="top-2"
          class="prime-calendar-spend prime-input"
          readonly
          inputClass="text-size_m"
        ></app-input-calendar>
      </div>

      <div class="input select-with-border">
        <app-dropdown
          (ngModelChange)="setItemDuration($event, item); calcDistribution(item)"
          [ngModel]="item.prime_duration"
          [name]="'prime_duration' + item.id"
          [ngModelOptions]="{ standalone: true }"
          [options]="durationMonths"
          class="spend-app-dropdown prime-input mt-0 mb-0"
          wrapperClass="text-size_m"
        ></app-dropdown>
      </div>
      <!--    <div *ngIf="selectedBudgetType === SPEND_TYPES.ACTUALS" class="input disabled"></div>-->

      <div class="input select-with-border">
        <app-dropdown
          optionValue="key"
          optionLabel="name"
          (ngModelChange)="setItemDistribution($event, item); calcDistribution(item)"
          [ngModel]="item.prime_distribution"
          [name]="'distribution_type_' + item.id"
          [ngModelOptions]="{ standalone: true }"
          [options]="distributionTypes"
          class="spend-app-dropdown mt-0 mb-0"
          wrapperClass="text-size_m"
          [disabled]="
            item.project_total !== item.original_prime_total && item.prime_distribution === DISTRIBUTION_TYPES.MANUAL
          "
          [appTooltip]="
            item.project_total !== item.original_prime_total && item.prime_distribution === DISTRIBUTION_TYPES.MANUAL
              ? 'Please fix the total value mismatch first.'
              : null
          "
        ></app-dropdown>
      </div>
    } @else {
      <div class="distribution-lever-missing"></div>
      <div class="distribution-lever-missing"></div>
      <div class="distribution-lever-missing"></div>
    }
  </div>

  <div class="months">
    <div class="input-wrapper month-input column">
      <div class="input">
        <app-spend-custom-input
          [ngClass]="{
            'subitem-spend-input-bg': isSubItem,
            'spend-input-bg': !isSubItem,
          }"
          [disabled]="true"
          class="app-custom-input prime-spend-input"
          [value]="item.year_total"
        >
        </app-spend-custom-input>
      </div>
    </div>
    @for (month of MONTHS_KEYS; track $index) {
      <div class="input-wrapper month-input column">
        <div class="input">
          <app-spend-custom-input
            (valueChange)="registerChange($event, item, month, 'monthly_prime')"
            class="app-custom-input prime-spend-input"
            [ngClass]="{
              'project-activity':
                !item.prime_monthly_disable[month] && item.prime_distribution !== DISTRIBUTION_TYPES.MANUAL,
              'subitem-spend-input-bg': isSubItem,
              'spend-input-bg': !isSubItem,
            }"
            [disabled]="
              !isSubItem || item.prime_monthly_disable[month] || item.prime_distribution !== DISTRIBUTION_TYPES.MANUAL
            "
            [value]="item.monthly_data[month]"
            [appTooltip]="
              (!item.prime_monthly_disable[month] && item.prime_distribution !== DISTRIBUTION_TYPES.MANUAL) ||
              item.prime_monthly_disable[month]
                ? tooltipContent
                : ''
            "
            tooltipPosition="bottom"
          >
          </app-spend-custom-input>
          <ng-template #tooltipContent>
            @if (!item.prime_monthly_disable[month] && item.prime_distribution !== DISTRIBUTION_TYPES.MANUAL) {
              Input field cannot be edited, as it is being distributed based on project activity budget.
            } @else if (item.prime_monthly_disable[month]) {
              Input field cannot be edited outside project activity.
            }
          </ng-template>
        </div>
      </div>
    }
  </div>
</div>
